import type { EstadoJogo } from '@core/motor/estados';
import { encaixeAtivoDe } from '@core/motor/estados';
import type { Evento } from '@core/motor/eventos';

/**
 * Alternância entre ocorrências válidas da âncora (T06-04).
 *
 * Só aparece quando o draft encaixado contém a letra-âncora mais de uma vez em
 * posições que cabem no tabuleiro. Diz por texto qual ocorrência está ativa e
 * oferece as setas; o atalho `Alt` + setas vive em `CampoDraft`, e o clique
 * direto sobre a letra vive no `Tabuleiro`. Três caminhos, um evento.
 */
export function AlternadorEncaixe({
  estado,
  despachar,
}: {
  estado: EstadoJogo;
  despachar: (evento: Evento) => void;
}) {
  if (estado.ancora === undefined || estado.draftProvisorio) return null;

  const validos = estado.encaixes.filter((e) => e.valido);
  if (validos.length < 2) return null;

  const ativo = encaixeAtivoDe(estado);
  const posicao = ativo === undefined ? 0 : validos.indexOf(ativo);
  const letra = estado.ancora.caractere.toUpperCase();

  return (
    <div className="encaixes" role="group" aria-label={`Ocorrência da letra ${letra} na âncora`}>
      <button
        type="button"
        className="encaixes__seta"
        onClick={() => despachar({ tipo: 'alternar-encaixe', direcao: -1 })}
        aria-label="Ocorrência anterior da âncora"
        title="Ocorrência anterior (Alt + ←)"
      >
        ‹
      </button>
      <span className="encaixes__texto" aria-live="polite">
        Letra {letra}: ocorrência {posicao + 1} de {validos.length} sobre a âncora
      </span>
      <button
        type="button"
        className="encaixes__seta"
        onClick={() => despachar({ tipo: 'alternar-encaixe', direcao: 1 })}
        aria-label="Próxima ocorrência da âncora"
        title="Próxima ocorrência (Alt + →)"
      >
        ›
      </button>
    </div>
  );
}
